import {SelectableCampaignTermsComponent} from './selectable-campaign-terms/selectable-campaign-terms.component';
import {OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MentionResponse} from '../../../models/mention';
import {SelectableCampaignTerm} from '../../../models/selectable-campaign-term';
import {ImageFile} from '../../../models/image-file';
import {AchooTextFieldComponent} from '../../core/achoo-text-field/achoo-text-field.component';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CampaignService} from '../../services/campaign/campaign.service';
import {UserService} from '../../services/user.service';
import {MentionService} from '../../services/mention/mention.service';
import {TermBindingModel, TermParam, TermParamType} from '../../../models/campaign-save';
import {Observable, ObservableInput} from 'rxjs/Observable';
import {StringUtils} from '../../utils/string.utils';
import {InfluencerCampaign} from '../../../models/influencer-campaign';
import {AchooTabsComponent} from '../../core/achoo-tabs/achoo-tabs.component';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';
import {Country} from '../../../models/country';
import {Platform} from '../../../models/platform';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {Campaign, CampaignCustomTerm} from '../../../models/campaign';
import {Subscription} from 'rxjs/Subscription';
import {FileAction} from './upload-file/upload-file.component';
import { ValidationHandlerService } from '../../core/validation-handler.service';
import { ErrorTemplate } from '../../../models/ErrorTemplate';
import {CommonConstant} from '../../app.constants';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {InfluencerSuggestion} from '../../../models/influencer-suggestion';
import {EventTrackerService, Page, UserActionType, ActivePages, ActionSource, TargetType, ActionDetails} from '../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../models/event-tracker';
import {InvalidAction} from '../../../models/user';
import {InfluencerGroupsService} from '../influencer-groups/influencer-groups.service';
import {CacheService} from '../../services/cache/cache.service';
import {CampaignInfluencerStatus as CampaignStatus} from '../../app.constants';
import { DateUtils } from '../../utils/date.utils';
import { WebUtils } from '../../utils/web.utils';

const TermRegex = /{{([^}}]+)?}}/g;

export enum CampaignTab {
  TERMS = 'terms',
  INFLUENCER = 'influencers',
  MATERIALS = 'materials'
}

export enum CampaignType {
  CREATION = 'CAMPAIGN_CREATION',
}

/**
 * Define several action type for Term
 */
export enum TermActionType {
  ADD = 'add',
  EDIT = 'edit',
  DELETE = 'delete'
}

/**
 * Define several status of campaign influencer
 */
export enum CampaignInfluencerStatus {
  NEW = 'new',
  INVITED = 'invited',
  ACCEPTED = 'accepted'
}


export abstract class CampaignsDetailComponent extends AbstractAchooComponent implements OnInit, OnDestroy {
  [x: string]: any;
  public campaignId: number;
  public campaignName = '';
  public _mentions: MentionResponse[] = [];
  public currentInputMention = '';
  public campaignBrief = '';
  public campaignAdditionalInfo = '';
  public selectableCampaignTerms: TermBindingModel[] = [];
  public materialImages: ImageFile[] = [];
  public campaignInfluencers: InfluencerCampaign[] = [];

  public tabKey: string = CampaignTab.TERMS;
  protected sub: Subscription;
  public isSavingCampaign: boolean;

  serviceErrorMessage: string;
  currentDeleteMention: MentionResponse;
  currentDeleteMentionIndex = -1;

  // use for bottom bar
  public isShowAddInfluencerToCampaignsFragment = false;
  public isShowAddInfluencerManuallyFragment = false;
  public isShowModifyCustomTerm = false;
  public activeBottomBar;
  public selectedCustomTerm: CampaignCustomTerm;
  public selectedToDeleteCustomTermId: number;
  // that use to store the list of influencer will be added to campaign
  public pendingInfluencerListAddToCampaign;
  public selectedInfluencerToAddCampaign: InfluencerSuggestion[];
  // keep the index of selected influencer in selection list to add manually
  public indexInfluencerManually: number;
  public processingInfluencerSuggestion: InfluencerSuggestion;

  // reference data
  public supportedCountryList: Country[] = [];
  public supportedPlatformList: Platform[] = [];

  public canCreateOrEditCampaign = true;
  public processingMentions: string[] = [];
  public isFetchingInfluencer = false;
  public campaignErrorMsg: string;

  private isCampaignHistory: boolean;
  private isCampaignInfluencer: boolean;

  protected isDirtyCampaignData = false;
  // on error because of invalid account level
  protected hasInvalidAccountLevelError = false;
  public addInfluencerAsAccepted: boolean;

  public exportLabel: string = this.translate.instant('campaigns.export_xls_campaign_name_btn');

  @ViewChild('serviceErrorPopup') serviceErrorPopup: AchooPopupComponent;
  @ViewChild('confirmRemoveMentionDialog') confirmRemoveMentionDialog: AchooPopupComponent;
  @ViewChild('mentionInput') mentionInput: AchooTextFieldComponent;
  @ViewChild('mainTabs') mainTabs: AchooTabsComponent;
  @ViewChild('ConfirmBackToCampaignListDialog') confirmBackToCampaignListDialog: AchooPopupComponent;
  @ViewChild('AlertAddCustomTermSuccess') alertAddCustomTermSuccess: AchooPopupComponent;
  @ViewChild('AlertEditCustomTermSuccess') alertEditCustomTermSuccess: AchooPopupComponent;
  @ViewChild('WarningDeleteCustomTermDialog') warningDeleteCustomTermDialog: AchooPopupComponent;
  @ViewChild('CampaignStatusDialog') CampaignStatusDialog: AchooPopupComponent;
  @ViewChild('CampaignErrorPopup') CampaignErrorPopup: AchooPopupComponent;

  /**
   * @param error
   * @param translate
   * @returns {any}
   */
  public static buildMessageErrorInArchive(error, translate) {
    if (!error || error.error_code !== 'invalid_account_level' || !error.data) {
      return {
        errorMsg: translate.instant('campaigns.unarchive_campaign_unexpect_error'),
        errorType: 'server error'
      };
    }

    const errorData = error.data;
    const availableSlots = errorData.availableSlots;

    if (availableSlots <= 0) {
      return {
        errorMsg: translate.instant('campaigns.unarchive_campaign_error_message', {
          maxValue: errorData.maxSlots
        }),
        errorType: 'invalid level'
      };
    }

    return {
      errorMsg: translate.instant('campaigns.unarchive_campaign_exceed_limit', {
        actualValue: errorData.addingSlots,
        maxValue: errorData.availableSlots
      }),
      errorType: 'invalid level'
    };
  }

  constructor(
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected translate: TranslateService,
    protected campaignService: CampaignService,
    protected groupService: InfluencerGroupsService,
    protected userService: UserService,
    protected mentionService: MentionService,
    private modalService: ModalService,
    protected validateErrorHandler: ValidationHandlerService,
    private referenceDataService: ReferenceDataService,
    protected eventTracker: EventTrackerService,
    protected cacheService: CacheService,
    protected defaultCampaignName?: string,
  ) {
    super(userService);
    this.campaignName = defaultCampaignName || '';
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.isCampaignHistory) {
        this.isCampaignHistory = params.isCampaignHistory;
      }
      if (params.isCampaignInfluencer) {
        this.isCampaignInfluencer = params.isCampaignInfluencer;
      }
    });
    super.ngOnInit();
    this.supportedCountryList = this.referenceDataService.countries;
    this.supportedPlatformList = this.referenceDataService.platforms;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  protected getSelectedTermCampaign(companyId) {
    this.campaignService.getSelectableCampaignTerms(companyId, 'CAMPAIGN_CREATION').subscribe(terms => {
        terms.forEach(x => {
          x.params = this.parseTerm(x);
          x.selected = false;
          x.companyId = companyId;
        });
        this.selectableCampaignTerms = terms;
      });
  }

  get mentions() {
    return this._mentions.map(x => x.keyword);
  }

  get selectedCampaignTerms() {
    return this.selectableCampaignTerms.filter(x => {
      return x.selected;
    });
  }

  protected saveAndSend() {
    if (this.tabKey === CampaignTab.TERMS) {
      this.tabKey = CampaignTab.INFLUENCER;
    } else if (this.tabKey === CampaignTab.INFLUENCER) {
      this.tabKey = CampaignTab.MATERIALS;
    } else if (this.tabKey === CampaignTab.MATERIALS) {
      this.createOrUpdateCampaign();
    }
  }
  abstract replaceTabState(tabKey: string);
  abstract getCampaign(): Campaign;
  abstract createOrUpdateCampaign();
  abstract isCampaignDataChanged();
  abstract getCampaignCachingKeys();

  protected sendEventWhenAddingInfluencersToCampaign(additinalInfluencers) {
    // track event to Segment
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
      id: this.campaignId,
      name: this.campaignName,
      type: TargetType.CAMPAIGN
    }, {
      action: UserActionType.UPDATE,
      actionDetails: ActionDetails.ADDED_INFLUENCERS,
      source: ActionSource.PAGE,
      influencers: additinalInfluencers
    }, undefined, {
      type: this.campaignId ? ActivePages.CAMPAIGN_EDIT : ActivePages.CAMPAIGN_NEW,
      name: this.campaignName,
      id : this.campaignId && Number(this.campaignId)
    });
  }

  protected handleSaveError(error: any): ObservableInput<any> {
    this.modalService.open(this.serviceErrorPopup, undefined, true);
    this.serviceErrorMessage = error.error.message || error.message || error.toString();
    return Observable.throw(error);
  }

  mentionInputKeyDown(evt: KeyboardEvent) {
    // Check if user hit Enter
    if (!evt || evt.keyCode !== 13) {
      return;
    }

    // Make sure they input something
    if (!this.currentInputMention || StringUtils.trim(this.currentInputMention) === '') {
      return;
    }

    // Determine type of mention
    const mention = this.campaignService.parseMentions(this.currentInputMention);
    // currently just use global language by default
    mention.language.push(0);

    // If we already have this mention, do nothing
    const existedMentions = this._mentions.find(item => StringUtils.trim(item.keyword).toLowerCase() === StringUtils.trim(mention.keyword).toLowerCase());
    if (!!existedMentions) {
      this.currentInputMention = '';
      this.mentionInput.setFocus();
      return;
    }

    // add this mention on UI
    this._mentions.push({
      id: -1,
      keyword: mention.keyword
    });
    // Clear input value
    this.currentInputMention = '';

    const activePage: ActivePage = {
      type: this.campaignId ? ActivePages.CAMPAIGN_EDIT : ActivePages.CAMPAIGN_NEW,
      name: this.campaignName,
      id : this.campaignId && Number(this.campaignId)
    };

    this.mentionService.processNewMention(mention, this.beforeProcessingNewMention.bind(this), this.afterProcessingNewMention.bind(this), activePage, ActionSource.PAGE);
  }

  private beforeProcessingNewMention(mention) {
    this.canCreateOrEditCampaign = false;
    this.processingMentions.push(mention.keyword);
  }

  private afterProcessingNewMention(data) {
    this.setDirtyData();
    this.markCampaignNotSaving();
    // if mention is not existed
    if (!data.alreadyExisted) {
      // has error during processing
      if (data.hasError) {
        // remove the processing mention
        const processingMention = this._mentions.findIndex(men => men.keyword.toLowerCase() === data.errorMention.keyword.toLowerCase());
        this._mentions.splice(processingMention, 1);
        // Return it to the input field
        this.currentInputMention = data.errorMention.keyword;
        this.mentionInput.setFocus();
      } else {
        setTimeout(() => {
          this.mentionInput.setFocus();
        }, 0);
        // Update the target ID in place.
        const selectdIndex = this._mentions.findIndex((m) => StringUtils.trim(m.keyword.toLowerCase()) === StringUtils.trim(data.newMention.keyword.toLowerCase()));
        this._mentions.splice(selectdIndex, 1, data.newMention); // Replace
      }
    } else {
      // if mention is existed
      const selectedMention = this._mentions.find(men => StringUtils.trim(men.keyword.toLowerCase()) === StringUtils.trim(data.newMention.keyword.toLowerCase()));
      if (selectedMention) {
        selectedMention.id = data.newMention.id;
      }
    }
    // after processing all mentions
    const inProgressMentions = this._mentions.filter(m => m.id === -1);
    if (inProgressMentions.length === 0) {
      // clear the blocker of Campaign editable
      this.canCreateOrEditCampaign = true;
      this.processingMentions = [];
    }
  }

  selectableCampaignTermsChange(event: SelectableCampaignTermsComponent) {
    this.updateTabs();
  }

  uploadFileChange(event) {
    this.updateTabs();
    this.setDirtyData();
  }

  protected extractParams(params: TermParam[]) {
    if (!params) {
      return null;
    }
    const result = {};
    params
      .filter(x => x.paramType !== TermParamType.Str)
      .forEach(x => {
        const val = x.type === 'int' ? parseInt(x.value, 10) : x.value;
        result[x.key] = {
          value: val,
          type: x.type
        };
      });
    return result;
  }

  onDeleteMention(index: number) {
    // on Premium or Enterprise can delete mention of campaign
    if (!this.hasPermissionOnCampaign()) {
      this.userService.doInvalidActionByLevel('Campaign Disabled');
      return;
    }
    const currentMention = this._mentions[index];
    if (!currentMention) {
      return;
    }
    this.modalService.openInCenter(this.confirmRemoveMentionDialog);
    this.currentDeleteMention = currentMention;
    this.currentDeleteMentionIndex = index;
  }

  protected hasPermissionOnCampaign() {
    return this.userService.isEnterpriseAccount() || this.userService.isPremiumAccount();
  }

  protected parseTerm(term: SelectableCampaignTerm): TermParam[] {
    if (!term) {
      return null;
    }
    if (!term.hasParams) {
      return [{
        content: term.summary,
        paramType: TermParamType.Str
      }];
    }
    let match, cursor = 0;
    const termStr = term.summary,
      params: TermParam[] = [];
    while (match = TermRegex.exec(termStr)) {
      params.push(
        {
          content: termStr.substr(cursor, match.index),
          paramType: TermParamType.Str
        },
        {
          key: match[1],
          paramType: TermParamType.Param,
          type: this.getParamType(match[1]),
          value: ''
        }
      );
      cursor = match.index + match[0].length;
    }
    params.push({
      content: termStr.substr(cursor, termStr.length - cursor),
      paramType: TermParamType.Str
    });
    return params;
  }

  private getParamType(key: string): string {
    const inx = key.indexOf('_');
    return inx > 0 ? key.substr(0, inx) : 'string';
  }

  backToCampaigns() {
    this.cacheService.enableCacheRemoving();
    this.modalService.close();
    if (this.isCampaignHistory) {
      this.router.navigateByUrl('/campaigns/history');
    } else if (this.isCampaignInfluencer) {
      this.router.navigate([`/campaigns/${this.campaignId}/influencer-list`], {
        queryParams: {
          activeAccount: this.activeAccount,
          campaignId: this.campaignId
        }
      });
    } else {
      this.router.navigateByUrl('/campaigns');
    }
  }

  updateTabs() {
    if (this.mainTabs) {
      this.mainTabs.delayUpdate();
    }
  }

  closeErrorMessage() {
    this.modalService.close();
  }

  closeConfirmMessageDialog() {
    this.modalService.close();
  }

  contactSupport() {
    this.userService.contactSupport();
  }

  confirmRemoveMention() {
    if (!this.currentDeleteMention) {
      this.modalService.close();
      return;
    }
    this._mentions.splice(this.currentDeleteMentionIndex, 1);
    this.modalService.close();
    this.currentDeleteMention = null;
    this.currentDeleteMentionIndex = -1;
    this.setDirtyData();
  }

  backToPreviousStep() {
    this.cacheService.enableCacheRemoving();
    if (this.tabKey === CampaignTab.TERMS) {
      if (this.isCampaignDataChanged()) {
        // Go from Terms to Campaign Overview
        this.modalService.openInCenter(this.confirmBackToCampaignListDialog);
      } else {
        this.backToCampaigns();
      }
    } else if (this.tabKey === CampaignTab.INFLUENCER) {
      // Go from Influencers to Terms
      this.replaceTabState(CampaignTab.TERMS);
      this.tabKey = CampaignTab.TERMS;
    } else if (this.tabKey === CampaignTab.MATERIALS) {
      // Go from Materials to Influencers
      this.replaceTabState(CampaignTab.INFLUENCER);
      this.tabKey = CampaignTab.INFLUENCER;
    }
  }

  goToNextStep() {
    if (this.tabKey === CampaignTab.TERMS) {
      // Go from Terms => Influencers
      this.replaceTabState(CampaignTab.INFLUENCER);
      this.tabKey = CampaignTab.INFLUENCER;
    } else if (this.tabKey === CampaignTab.INFLUENCER) {
      // Go from Influencers => Materials
      this.replaceTabState(CampaignTab.MATERIALS);
      this.tabKey = CampaignTab.MATERIALS;
      return;
    } else if (this.tabKey === CampaignTab.MATERIALS) {
      // Save and return to Campaign Overview
      this.saveAndSend();
    }
  }

  openAddInfluencerToCampaign() {
    this.isShowAddInfluencerToCampaignsFragment = true;
    this.activeBottomBar = 'active';
  }

  closeAddInfluencerToCampaign(data) {
    this.isShowAddInfluencerToCampaignsFragment = false;
    this.activeBottomBar = 'inactive';
  }

  addMoreInfluencerToCampaign(additinalInfluencers) {
    this.setDirtyData();
    // clear cached selected influencer suggestions
    this.selectedInfluencerToAddCampaign = [];
    // keep the list availabel influencers
    this.pendingInfluencerListAddToCampaign = additinalInfluencers;
    // Clear the previous selections before adding new ones
    this.campaignInfluencers = this.campaignInfluencers.filter(ci => ci.campaign_influencer_status !== CampaignInfluencerStatus.NEW);
    const alreadySelectedInflIds = this.campaignInfluencers.map(ci => ci.influencer_id);
    // update UI
    additinalInfluencers.forEach(influencer => {
      if (alreadySelectedInflIds.indexOf(influencer.influencer_id) < 0) {
        this.campaignInfluencers.push({
          campaign_influencer_id: influencer.influencerId,
          influencer_id: influencer.influencer_id,
          influencer_name: influencer.influencerName,
          campaign_influencer_status: CampaignInfluencerStatus.NEW,
          campaign_influencer_number_of_post: 0,
          campaign_influencer_platformBlogs: false,
          campaign_influencer_platformInstagram: false,
          campaign_influencer_platformYoutube: false,
          campaign_influencer_platformSnapchat: false,
          campaign_influencer_platformTwitter: false,
          campaign_influencer_platformPinterest: false,
          campaign_influencer_platformFacebook: false,
          campaign_influencer_platformTikTok: false,
          campaign_influencer_reach: influencer.reach,
          campaign_influencer_engagement: influencer.engagement,
          campaign_influencer_impact: influencer.impact,
          influencer_profile_picture: influencer.profilePicture,
          country_code: influencer.countryCode,
          country: {
            name: influencer.countryName,
            code: influencer.countryCode
          },
          is_accepted: influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name
        });
      } else {
        const addedInfluencerIndex = this.campaignInfluencers.findIndex(ci => ci.influencer_id === influencer.influencer_id);
        const addAsAccepted = influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name;
        this.campaignInfluencers[addedInfluencerIndex].is_accepted = addAsAccepted;
      }
    });
    this.closeAddInfluencerToCampaign({
      resetSelectedInfluencer: false
    });
  }

  get numberAvailabelMaterialFile() {
    return this.materialImages.filter((file) => file.action !== FileAction.DELETE).length;
  }

  public warningDeleteTerm(termId) {
    this.selectedToDeleteCustomTermId = termId;
    this.modalService.openInCenter(this.warningDeleteCustomTermDialog);
  }

  public showActiveOrArchiveCampaignPopup() {
    this.modalService.openInCenter(this.CampaignStatusDialog, null, 'campaign-status-dialog');
  }

  public changeCampaignStatus() {
    this.modalService.close();
    if (this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE) {
      this.campaignArchivedAt = DateUtils.convertDateToString(new Date(), 'dd-MM-yyyy');
      this.campaignStatus = CampaignStatus.ARCHIVED;
      this.isActiveCampaign = false;
      this.isArchivedCampaign = true;
      this.campaignService.archiveCampaign(this.campaignId).subscribe(
        res => {
          this.userService.triggerUpdateActivatedInfluencers();
        },
        error => {
          this.campaignErrorMsg = this.translate.instant('campaigns.free_user_campaign_err_msg');
          this.campaignStatus = CampaignStatus.ACTIVE;
          this.isActiveCampaign = true;
          this.isArchivedCampaign = false;
          this.modalService.openInCenter(this.CampaignErrorPopup);
        }
      );
    } else {
      this.campaignStatus = CampaignStatus.ACTIVE;
      this.isActiveCampaign = true;
      this.isArchivedCampaign = false;
      this.campaignService.unarchiveCampaign(this.campaignId).subscribe(
        res => {
          this.userService.triggerUpdateActivatedInfluencers();
        },
        error => {
          this.campaignStatus = CampaignStatus.ARCHIVED;
          this.isActiveCampaign = false;
          this.isArchivedCampaign = true;

          if (error.status === 403) {
            this.campaignErrorMsg = this.translate.instant('campaigns.free_user_campaign_err_msg');
            this.modalService.openInCenter(this.CampaignErrorPopup);
          } else {
            const serverError = CampaignsDetailComponent.buildMessageErrorInArchive(error.error, this.translate);
            if (serverError.errorType === 'invalid level') {
              this.userService.doInvalidActionByLevel('Active Campaign', serverError.errorMsg);
            } else {
              this.campaignErrorMsg = serverError.errorMsg;
              this.modalService.openInCenter(this.CampaignErrorPopup);
            }
          }
        }
      );
    }

    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN,
      {
        type: TargetType.CAMPAIGN,
        id: this.campaignId,
        name: this.campaignName
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.PAGE,
        actionDetails: this.campaignStatus === CampaignStatus.ARCHIVED ? ActionDetails.ARCHIVED_CAMPAIGN : ActionDetails.UNARCHIVED_CAMPAIGN
      }, undefined, undefined);
  }

  public deleteCustomTerm() {
    this.modalService.close();
    const termId = this.selectedToDeleteCustomTermId;
    this.campaignService
    .deleteTerm(termId)
    .subscribe(res => {
      this.selectableCampaignTerms = this.selectableCampaignTerms
        .filter( term => term.id !== termId);
    });
  }

  public showModifyTerm(term: CampaignCustomTerm) {
    this.selectedCustomTerm = term;
    this.isShowModifyCustomTerm = true;
    this.activeBottomBar = 'active';
  }

  public modifyCustomTerm(term: CampaignCustomTerm, isAddNew: boolean) {
    const isAddNewAction = isAddNew;
    let termData = new CampaignCustomTerm();
    termData = {
      campaignType: CampaignType.CREATION,
      companyId: this.userService.getCompanyId(),
      summary: term.summary,
      body: term.body,
      heading: term.heading
    };
    if (!isAddNewAction) {
      termData.id = term.id;
    }

    const errors: ErrorTemplate[] = this.campaignService.validateCustomTerm(termData);

    if (errors.length > 0) {
      this.validateErrorHandler.shouldDisplayErrors(true);
      this.validateErrorHandler.updateErrors(errors);
    } else {
      if (isAddNewAction) {
        this.campaignService
          .addCustomTerm(termData)
          .subscribe(res => {
            this.setDirtyData();
            this.selectableCampaignTerms.push(res);
            this.closeCustomTermDetailsBottomBar();
            this.modalService.open(this.alertAddCustomTermSuccess, undefined, true);
          });
      } else {
        this.campaignService
          .editCustomTerm(termData, termData.id)
          .subscribe(res => {
            // set dirty data
            this.setDirtyData();
            // update edited term
            const result: CampaignCustomTerm = res;
            const editedTermList = this.selectableCampaignTerms.filter( item => item.id === result.id);
            if (result && editedTermList) {
              const editedTerm = editedTermList[0];
              editedTerm.summary = result.summary;
              editedTerm.heading = result.heading;
              editedTerm.body = result.body;
            }
            this.closeCustomTermDetailsBottomBar();
            this.modalService.open(this.alertEditCustomTermSuccess, undefined, true);
          });
      }
    }
  }

  public closeCustomTermDetailsBottomBar() {
    this.isShowModifyCustomTerm = false;
    this.activeBottomBar = 'inactive';
  }

  protected addNewAcceptedToCampaign(campaignId, influencers, errorCallback?: () => void) {
    this.hasInvalidAccountLevelError = false;
    const newAcceptedInfluencers = influencers.filter(influencer => influencer.campaign_influencer_status === CampaignInfluencerStatus.NEW && influencer.is_accepted)
      .map(infl => ({
        action: 'add',
        domain: infl.influencer_name,
        influencer_id: infl.campaign_influencer_id,
        profile_image: infl.influencer_profile_picture,
        status: CampaignInfluencerStatus.ACCEPTED
      }));

    if (newAcceptedInfluencers.length > 0) {
      this.campaignService.addInfluencerToCampaign({
        campaign_id: campaignId,
        influencers: newAcceptedInfluencers
      }).subscribe(() => {
        this.userService.triggerUpdateActivatedInfluencers();
        this.router.navigateByUrl('/campaigns');
      }, (err) => {
        if (err.error.data === 'invalid_level') {
          this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
          this.sendInvalidActionToSegement(this.groupService.extractLimitInfoFromErrorMessage(err.error.message,
            this.campaignInfluencers.length, this.userService.maxCampaignInfluencers, true), {
            campaign_id: this.campaignId,
            campaign_name: this.campaignName,
            influencers: influencers
          });
        }

        if (errorCallback) {
          errorCallback();
        }
      });
    } else {
      this.router.navigateByUrl('/campaigns');
    }
  }

  protected sendInvalidActionToSegement(limitInfo, influencerAddToCampaign) {
    const detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true,
      limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);

    // send event when adding to Campaign
    this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
      id: this.campaignId,
      name: this.campaignName,
      type: TargetType.CAMPAIGN
    }, {
      action: this.campaignId > 0 ? UserActionType.UPDATE : UserActionType.CREATE,
      actionDetails: ActionDetails.ADDED_INFLUENCERS,
      source: ActionSource.ACTION_VIEW,
      ...influencerAddToCampaign
    }, undefined, {
      type: this.campaignId > 0 ? ActivePages.CAMPAIGN_EDIT : ActivePages.CAMPAIGN_NEW,
    });
  }

  private isActiveOnPlatform(influencer, platformName) {
    return influencer.channels && influencer.channels.find(channel => channel.platform && channel.platform.name === platformName) !== undefined;
  }

  showFragmentAddInfluencerManually(evt) {
    this.selectedInfluencerToAddCampaign = evt.selectedInfluencers;
    this.indexInfluencerManually  = evt.processingIndex;
    this.processingInfluencerSuggestion = evt.influencerSuggestion;
    this.isShowAddInfluencerManuallyFragment = true;
    this.isShowAddInfluencerToCampaignsFragment = false;
    this.addInfluencerAsAccepted = evt.addInfluencerAsAccepted;
  }

  closeFragmentAddInfluencerManually(influencer?: InfluencerSuggestion) {
    if (influencer) {
      this.selectedInfluencerToAddCampaign.splice(this.indexInfluencerManually, 1, influencer);
    }
    this.processingInfluencerSuggestion = null;
    this.indexInfluencerManually = null;
    this.isShowAddInfluencerToCampaignsFragment = true;
    this.isShowAddInfluencerManuallyFragment = false;
  }

  companyChangeCallback(companyId) {
    this.getSelectedTermCampaign(companyId);
  }

  setDirtyData() {
    this.isDirtyCampaignData = true;
  }

  markCampaignNotSaving() {
    this.isSavingCampaign = false;
  }

  modifyCampaignData() {
    this.setDirtyData();
  }

  get campaignDialogHeader() {
    return this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE ? this.translate.instant('campaigns.active_campaign_message_header') : this.translate.instant('campaigns.archive_campaign_message_header');
  }

  get campaignDialogContent() {
    return this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE ? this.translate.instant('campaigns.archive_campaign_message_content') : this.translate.instant('campaigns.active_campaign_message_content');
  }

  get campaignDialogButtonText() {
    return this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE ? this.translate.instant('campaigns.archive_campaign') : this.translate.instant('campaigns.activate_campaign');
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-detail.component.ts